import React from "react";

const EventTransportation = () => {
  return (
    <>
      {/* ===== BREADCRUMB ===== */}








<section
        className="breadcrumb-section"
        style={{
          backgroundImage:
            "url(/images/background/inner-banner-bg.jpg)",
        }}
      >
        <div className="container">
          <div className="banner-content text-center">
            <h1>Event Transportation</h1>
          </div>
        </div>
      </section>



      {/* ===== MAIN CONTENT SECTION ===== */}
      <section className="py-5 bg-white">
        <div className="container">
          <div className="row align-items-center">

            {/* IMAGE */}
            <div className="col-lg-6 mb-4 mb-lg-0">
              <img
                src="/images/gallery/06.jpeg"
                alt="Event Transportation Services in Pune"
                className="img-fluid rounded shadow-lg"
              />
            </div>

            {/* CONTENT */}
            <div className="col-lg-6">
              <h2 className="mb-3">
                <span className="text-danger">Event</span> Transportation Services
              </h2>

              <p>
                Pune Corporate Cars India Pvt. Ltd. provides comprehensive
                transportation solutions for corporate events, weddings,
                exhibitions, product launches, conferences, and large-scale
                gatherings across Pune and major cities in India.
              </p>

              <p>
                We understand that event transportation requires precise
                planning, flawless execution, and real-time coordination.
                Our experienced operations team ensures smooth movement
                of guests, delegates, artists, and VIPs throughout the event.
              </p>

              <p>
                From airport transfers and hotel pickups to venue shuttles
                and post-event drop-offs, our professional chauffeurs and
                well-maintained fleet deliver punctual, safe, and comfortable
                travel experiences.
              </p>
            </div>

          </div>
        </div>
      </section>

      {/* ===== WHY CHOOSE US ===== */}
      <section className="py-5 bg-light">
        <div className="container">

          <div className="row mb-4">
            <div className="col-12 text-center">
              <h2 className="mb-3">Why Choose Us for Event Transportation?</h2>
              <p className="text-muted">
                A trusted mobility partner for seamless event execution
                and guest satisfaction.
              </p>
            </div>
          </div>

          <div className="row">

            <div className="col-md-6 mb-4">
              <ul className="list-unstyled">
                <li className="mb-3">✔ End-to-end event transportation planning</li>
                <li className="mb-3">✔ Guest, VIP & artist transportation</li>
                <li className="mb-3">✔ Dedicated event coordinators</li>
                <li className="mb-3">✔ Airport, hotel & venue transfers</li>
              </ul>
            </div>

            <div className="col-md-6 mb-4">
              <ul className="list-unstyled">
                <li className="mb-3">✔ Premium sedans, SUVs & luxury vehicles</li>
                <li className="mb-3">✔ On-ground fleet & chauffeur management</li>
                <li className="mb-3">✔ 24×7 operations & real-time coordination</li>
                <li className="mb-3">✔ Safety, punctuality & service excellence</li>
              </ul>
            </div>

          </div>

        </div>
      </section>
    </>
  );
};

export default EventTransportation;
